import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";

import { IgTypography } from "@intelligems/ig-theme";
import { Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useGraphValueFormatter } from "@src/features/analytics/hooks/use-graph-value-formatter";

export const IgBarCustomMetricAnalyticsTooltip = (
  props: TooltipProps<ValueType, NameType>
) => {
  const { active, payload, label } = props;
  const theme = useTheme();
  const graphValueFormatter = useGraphValueFormatter();
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        padding: "10px",
        borderRadius: "5px",
        minWidth: "123px",
        // maxWidth: "326px",
        backgroundColor: "rgba(73, 76, 80, 0.92)",
      }}
    >
      <Grid container direction={"column"} rowSpacing={1}>
        <Grid>
          <IgTypography
            sx={{
              fontWeight: 600,
            }}
            color={"dark"}
          >
            {label}
          </IgTypography>
        </Grid>

        {payload[0].payload.n_visitors ? (
          <Grid
            container
            direction={"row"}
            alignItems={"center"}
            columnSpacing={1}
          >
            <Grid>
              <IgTypography color={"dark"}>Visitors triggered:</IgTypography>
            </Grid>
            <Grid>
              <IgTypography
                color={"dark"}
                sx={{
                  fontWeight: 600,
                }}
              >
                {graphValueFormatter({
                  isAxisTick: false,
                  value: payload[0].payload.n_visitors_triggered,
                  configDataTypes: ["number"],
                })}
              </IgTypography>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
};
